/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section6_P1Inputs */

const en_terms_section6_p1 = /** @type {(inputs: Terms_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to this page. Your continued use of PureJSON after changes constitutes acceptance of the updated terms.`)
};

const ko_terms_section6_p1 = /** @type {(inputs: Terms_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`당사는 언제든지 본 약관을 수정할 권리를 보유합니다. 변경 사항은 이 페이지에 게시된 즉시 효력이 발생합니다. 변경 후에도 PureJSON을 계속 사용하면 업데이트된 약관에 동의하는 것으로 간주됩니다.`)
};

const ja_terms_section6_p1 = /** @type {(inputs: Terms_Section6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当社はいつでも本規約を変更する権利を留保します。変更はこのページに掲載された時点で直ちに有効となります。変更後もPureJSONの使用を継続することは、更新された規約への同意を意味します。`)
};

/**
* | output |
* | --- |
* | "We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to this page. Your continued use of PureJSON after..." |
*
* @param {Terms_Section6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section6_p1 = /** @type {((inputs?: Terms_Section6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section6_p1(inputs)
	if (locale === "ko") return ko_terms_section6_p1(inputs)
	return ja_terms_section6_p1(inputs)
});